var exports = {
  "x6": "GuildListDMItem.module__button___ZncwS2",
  "V8": "GuildListDMItem.module__relative___ZncwS2",
  "PH": "GuildListDMItem.module__fullSize___ZncwS2",
  "SU": "GuildListDMItem.module__muted___ZncwS2",
};

module.exports = exports;
